export abstract class ConfirmDialogBase {
}
